import type { MenuProps } from '@mui/material'
import { Menu } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { cloneElement, isValidElement, useMemo, useState } from 'react'

export interface DropdownMenuProps extends Partial<MenuProps> {
  anchor: ReactNode
  children: ReactNode
}

const DropdownMenu: FC<DropdownMenuProps> = ({
  anchor,
  children,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>()

  const wrappedAnchor = useMemo(() => {
    const onClick = (e: any) => {
      setAnchorEl(e.currentTarget)
    }

    if (isValidElement<Record<string, unknown>>(anchor)) {
      return cloneElement(anchor, {
        ...anchor.props,
        onClick,
      })
    }

    return <div onClick={onClick}>{anchor}</div>
  }, [anchor])

  return (
    <>
      {wrappedAnchor}
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
        {...props}
      >
        {children}
      </Menu>
    </>
  )
}

export default DropdownMenu
